import { CheckCircle, Signature } from 'lucide-react'
import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'

function GmailUpdatePrimarySignatureDisplayComponent({
  nodeExecution,
}: WorkflowToolComponentProps) {
  const inputs = nodeExecution.inputs

  const signature = inputs.signature || inputs.signatureText || 'Signature updated'
  const signaturePreview = signature.length > 100 ? signature.slice(0, 100) + '...' : signature

  return (
    <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
      <div className="flex items-start gap-4 px-4 py-3">
        <div className="mt-1 flex-shrink-0">
          <div className="rounded-full bg-green-100 p-2">
            <CheckCircle className="h-5 w-5 text-green-600" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <div className="mb-2 flex items-center gap-2">
            <Signature className="h-4 w-4 text-blue-500" />
            <div className="text-sm font-semibold text-gray-900">Primary signature updated</div>
          </div>

          <div className="rounded-2xl border border-gray-200 bg-gray-50 p-3">
            <div className="whitespace-pre-wrap text-xs text-gray-700">{signaturePreview}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

function downloadGmailUpdatePrimarySignature(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function gmailUpdatePrimarySignatureToMarkdown(nodeExecution: NodeExecution): string {
  const inputs = nodeExecution.inputs
  const signature = inputs.signature || inputs.signatureText || 'Signature updated'

  return `## Primary Signature Updated

**New Signature:**
${signature}

---
`
}

export const GmailUpdatePrimarySignatureDisplay = createWorkflowToolComponent(
  GmailUpdatePrimarySignatureDisplayComponent,
  downloadGmailUpdatePrimarySignature,
  gmailUpdatePrimarySignatureToMarkdown
)
